<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('home.setFavorites')"
    :visible.sync="setFavoritesItemDialog"
    width="800px"
  >
    <div>
      <!-- 选择菜单 -->
      <div class="hasSelect" style="margin-top: 10px">{{ $t('home.selectMenu') }}</div>
      <div style="height: 250px; width: 100%">
        <el-select
          v-model="selectMenu"
          :placeholder="$t('customerManagements.SOUrceName')"
          clearable
          filterable
          multiple
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in pcMenuList"
            :key="index"
            :label="item.name"
            :value="item.title"
          />
        </el-select>
      </div>
      <div style="text-align: right">
        <!-- 取消 -->
        <el-button @click="setFavoritesItemDialog = false">{{ $t('GlobalSetObj.cancel') }}
        </el-button>
        <!-- 确认 -->
        <el-button type="primary" @click="submitForm">{{ $t('changepwd.confirm') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { RouterObj } from '@/lang/type/route';
import { collectMenu } from '@/api/user';

export default {
  name: 'FavoritesItem',
  props: {
    pcMenuList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    showMenuList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      // 修改密码弹窗
      setFavoritesItemDialog: false,
      routerObjLang: RouterObj,
      selectMenu: []
    };
  },
  methods: {
    submitForm() {
      const data = {
        source: 1,
        userId: this.$store.state.user.id,
        menuTitle: this.selectMenu
      };
      if (this.selectMenu && this.selectMenu.length > 20) {
        this.$message.error(this.$t('home.max20'));
      } else {
        collectMenu(data).then((res) => {
          if (res.code === 200) {
            this.$emit('childrenSearch');
            this.setFavoritesItemDialog = false;
          }
        });
      }
    },
    showSetFavoritesItemDialog() {
      if (this.showMenuList.length > 0) {
        this.selectMenu = this.showMenuList.map((item) => item.title);
      }
      this.setFavoritesItemDialog = true;
    }
  }
};
</script>

<style scoped>
@import '../index.css';
</style>
